import React from 'react'
import { Typography } from '@mui/material'
import { stMob } from './styles'
import moment from 'moment'

export function formatHorario(horario) {
  return moment(horario.dataInicio).format('HH:mm') + ' às ' + moment(horario.dataFinal).format('HH:mm')
}

export function setLottieSpeed(lottieRef, speed = 4) {
  if (lottieRef.current) {
    lottieRef.current.setSpeed(speed)
  }
}

export function status(horario, solicitei, reagendavel = false) {
  if (reagendavel)
    return (
      <Typography variant='body2' color={'warning.main'} fontWeight={'bold'}>
        REAGENDAR
      </Typography>
    )
  if (horario.status === 'livre') {
    if (horario.promocao) {
      return (
        <>
          <Typography sx={{ textDecoration: 'line-through', color: 'grey' }} variant='body2' fontSize='13px'>
            {horario.valor.toLocaleString('pt-BR', {
              style: 'currency',
              currency: 'BRL',
            })}
          </Typography>
          <Typography sx={{ color: 'success.green' }} variant='body1' fontWeight='bold' fontSize='13px'>
            {horario.valorPromocional.toLocaleString('pt-BR', {
              style: 'currency',
              currency: 'BRL',
            })}
          </Typography>
        </>
      )
    } else
      return (
        <Typography variant='body2' sx={{ fontSize: '14px', fontWeight: 'bold', textAlign: 'center' }}>
          {horario.valor.toLocaleString('pt-BR', {
            style: 'currency',
            currency: 'BRL',
          })}
        </Typography>
      )
  } else {
    if (!solicitei)
      return (
        <Typography variant='body2' color='text.secondary' fontWeight='bold' fontSize='11px'>
          OCUPADO
        </Typography>
      )
    else if (solicitei && horario.status === 'AGENDADO')
      return (
        <Typography variant='body2' color={'success.main'} fontWeight={'bold'}>
          {horario.status}
        </Typography>
      )
    else if (solicitei && horario.status === 'SOLICITADO')
      return (
        <Typography variant='body2' sx={stMob.colorSolicitado}>
          {horario.status}
        </Typography>
      )
  }
}

export const disabledHorarios = (userUCtx, sttPg, horario, invalidGrade) => {
  if (invalidGrade) {
    return 'invalido'
  }
  if (horario.idusuario) {
    if (userUCtx.usuario?.idusuario === horario.idusuario) return 'agendei'
    else return 'invalido'
  } else if (sttPg.selectedHorarios.length !== 0) {
    if (sttPg.selectedHorarios.some(selected => selected.dataInicio === horario.dataInicio)) {
      return 'selecionado'
    } else {
      return !sttPg.selectedHorarios.some(
        selected => moment(selected.dataInicio).isSame(moment(horario.dataFinal)) || moment(selected.dataFinal).isSame(moment(horario.dataInicio)),
      )
        ? 'invalido'
        : 'livre'
    }
  } else {
    return 'livre'
  }
}
